import { render } from "./ProjectPublicationsFormv2.vue?vue&type=template&id=170f7286"
import script from "./ProjectPublicationsFormv2.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationsFormv2.vue?vue&type=script&lang=js"

import "./ProjectPublicationsFormv2.vue?vue&type=style&index=0&id=170f7286&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__